const BrandCreator = {
    namespaced: true,
    state: {
        searchWordPills: []
    },
    getters: {
        getSearchWordPills(state) {
            return state.searchWordPills;
        },
        getSearchWordString(state) {
            return state.searchWordPills.map((item) => item.value).join(' ');
        }
    },
    mutations: {
        setSearchWordPillsState(state, payload) {
            state.searchWordPills = payload;
        },
    },
    actions: {
        addSearchWordPill({ commit, state }, pillObj) {
            let newSearchWordPillsArray = [...state.searchWordPills];

            newSearchWordPillsArray.push({
                value: pillObj.value,
                colorClass: pillObj.colorClass,
            });

            commit('setSearchWordPillsState', newSearchWordPillsArray);
        },
        removeSearchWordPill({ commit, state }, pillObj) {
            const searchWordPills = [...state.searchWordPills];

            const newSearchWordPillsArray = searchWordPills.filter(item => {
                return item.value !== pillObj.value;
            });


            commit('setSearchWordPillsState', newSearchWordPillsArray);
        },
        resetSearchWordPills( {commit} ) {
            commit('setSearchWordPillsState', []);
        }
    }
}

export default BrandCreator;